import { IPlantCategory } from 'src/models/Products';

type IAction = {
  type: string;
  payload: TState;
};

type TState = {
  isFetching: boolean;
  isLoaded: boolean;
  products: IPlantCategory[];
};

const initialState: TState = {
  isFetching: true,
  isLoaded: false,
  products: [],
};

export const productsAvailableReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case 'START_LOADING_ACTION':
      return { ...state, ...action.payload };

    case 'FINISHED_LOADING_PRODUCTS_ACTION':
      return { ...state, ...action.payload };

    case 'FAILED_LOADING_PRODUCTS_ACTION':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export const startFetchingProducts = () => ({
  type: 'START_LOADING_ACTION',
  payload: {
    isFetching: true,
    isLoaded: false,
    products: [],
  },
});

export const setAvailableProducts = (payload: IPlantCategory[]) => ({
  type: 'FINISHED_LOADING_PRODUCTS_ACTION',
  payload: {
    products: payload,
    isFetching: false,
    isLoaded: true,
  },
});

export const failedFetchingProducts = () => ({
  type: 'FAILED_LOADING_PRODUCTS_ACTION',
  payload: {
    isFetching: false,
    isLoaded: false,
    products: [],
  },
});
